(function () {
  function findSections(scope, selector) {
    var sections = [];
    if (scope && scope.matches && scope.matches(selector)) sections.push(scope);
    if (scope && scope.querySelectorAll) {
      sections = sections.concat(Array.prototype.slice.call(scope.querySelectorAll(selector)));
    }
    return sections;
  }

  function parseProduct(root, selector) {
    var script = root.querySelector(selector);
    if (!script) return null;

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      console.error('Try Miracle product data could not be parsed.', error);
      return null;
    }
  }

  function cartRootPath() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function toVariantId(value) {
    if (value == null || value === '') return null;
    var digits = String(value).trim();
    if (!/^\d+$/.test(digits)) return null;
    var numeric = Number(digits);
    if (!Number.isFinite(numeric) || numeric <= 0) return null;
    return Number.isSafeInteger(numeric) ? numeric : digits;
  }

  function isGenericBrowserError(message) {
    var text = String(message || '').toLowerCase();
    if (!text) return true;
    return text.indexOf('did not match the expected pattern') !== -1
      || text.indexOf("didn't match the expected pattern") !== -1
      || text.indexOf('unexpected token') !== -1
      || text.indexOf('unexpected end of json') !== -1
      || text.indexOf('json parse') !== -1
      || text.indexOf('failed to fetch') !== -1
      || text.indexOf('load failed') !== -1
      || text.indexOf('networkerror') !== -1
      || text.indexOf('network request failed') !== -1;
  }

  function checkoutErrorMessage(error) {
    var message = error && error.message ? error.message : '';
    if (isGenericBrowserError(message)) return 'Unable to add these items. Please try again.';
    return message;
  }

  function parseCartJson(response) {
    return response.text().then(function (text) {
      var data = null;
      if (text && String(text).trim()) {
        try {
          data = JSON.parse(text);
        } catch (error) {
          throw new Error('Unable to add these items. Please try again.');
        }
      }
      if (!response.ok || (data && data.status)) {
        throw new Error((data && (data.description || data.message)) || 'Unable to add these items to your cart.');
      }
      return data;
    });
  }

  var cartQueue = Promise.resolve();

  function enqueueCartTask(task) {
    cartQueue = cartQueue.catch(function () {}).then(task);
    return cartQueue;
  }

  function requestCart(path, payload) {
    var options = {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      }
    };
    if (payload) options.body = JSON.stringify(payload);
    return fetch(cartRootPath() + path, options).then(parseCartJson);
  }

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function usesWhiteTowel(color) {
    return ['white', 'terracotta', 'sky blue', 'silver grey', 'ivory'].indexOf(normalize(color)) !== -1;
  }

  function canonicalSize(value) {
    var text = normalize(value);
    var sizes = ['split king', 'cali king', 'california king', 'twin xl', 'standard', 'queen', 'twin', 'full', 'king'];
    return sizes.find(function (size) { return text.indexOf(size) !== -1; }) || text;
  }

  function friendlySize(value) {
    var labels = {
      'split king': 'Split King',
      'cali king': 'Cali King',
      'california king': 'California King',
      'twin xl': 'Twin XL',
      standard: 'Standard',
      queen: 'Queen',
      twin: 'Twin',
      full: 'Full',
      king: 'King'
    };
    var canonical = canonicalSize(value);
    return labels[canonical] || value;
  }

  function friendlyColor(value) {
    return normalize(value) === 'navy' ? 'Navy Blue' : value;
  }

  function canonicalFabric(value) {
    var text = normalize(value);
    return text.indexOf('extra luxe') !== -1 ? 'extra luxe' : 'clean and cool';
  }

  function getOptionIndex(product, optionType) {
    if (!product || !Array.isArray(product.options)) return -1;

    return product.options.findIndex(function (option) {
      var name = normalize(typeof option === 'string' ? option : option.name);
      if (optionType === 'color') return name.indexOf('color') !== -1 || name.indexOf('colour') !== -1;
      return name.indexOf(optionType) !== -1;
    });
  }

  function availableVariants(product) {
    if (!product || !Array.isArray(product.variants)) return [];
    return product.variants.filter(function (variant) { return variant.available; });
  }

  function excludeExtraLuxe(product) {
    if (!product || !Array.isArray(product.variants)) return product;
    // Filter once so URL selection, availability, and all cart fallbacks agree.
    return Object.assign({}, product, {
      variants: product.variants.filter(function (variant) {
        return !variant.options.some(function (option) {
          return canonicalFabric(option) === 'extra luxe';
        }) && canonicalFabric(variant.title) !== 'extra luxe';
      })
    });
  }

  function findVariant(product, color, size, fabric, requireAvailable) {
    if (!product || !Array.isArray(product.variants)) return null;
    var colorIndex = getOptionIndex(product, 'color');
    var sizeIndex = getOptionIndex(product, 'size');
    var fabricIndex = getOptionIndex(product, 'fabric');

    return product.variants.find(function (variant) {
      if (requireAvailable && !variant.available) return false;
      if (colorIndex >= 0 && normalize(variant.options[colorIndex]) !== normalize(color)) return false;
      if (sizeIndex >= 0 && canonicalSize(variant.options[sizeIndex]) !== canonicalSize(size)) return false;
      if (fabricIndex >= 0 && fabric && canonicalFabric(variant.options[fabricIndex]) !== canonicalFabric(fabric)) return false;
      return true;
    }) || null;
  }

  function resolveVariant(product, color, size, preferredFabric) {
    return findVariant(product, color, size, preferredFabric, true)
      || findVariant(product, color, size, '', true)
      || findVariant(product, color, size, preferredFabric, false)
      || findVariant(product, color, size, '', false);
  }

  var upsellFallbackColors = {
    standard: ['stone', 'white', 'ivory', 'sky blue', 'sand', 'charcoal', 'navy', 'terracotta', 'silver grey', 'slate blue', 'sage', 'rosewood'],
    king: ['sand', 'stone', 'white', 'sage', 'terracotta', 'charcoal', 'sky blue', 'navy', 'silver grey', 'slate blue', 'rosewood', 'ivory']
  };

  function findRelatedVariant(product, color, size, fabric, prioritizeColorAcrossSizes) {
    if (!product || !Array.isArray(product.variants)) return null;
    var variants = availableVariants(product);
    var colorIndex = getOptionIndex(product, 'color');
    var sizeIndex = getOptionIndex(product, 'size');
    var fabricIndex = getOptionIndex(product, 'fabric');
    if (!variants.length) return null;

    var requestedColor = normalize(color);
    var requestedSize = canonicalSize(size);
    var requestedFabric = canonicalFabric(fabric);
    var sizes = [];
    variants.forEach(function (variant) {
      var value = sizeIndex >= 0 ? variant.options[sizeIndex] : size;
      var key = canonicalSize(value);
      if (key && sizes.indexOf(key) === -1) sizes.push(key);
    });
    sizes = [requestedSize].concat(sizes.filter(function (value) { return value !== requestedSize; }));

    function variantsForSize(targetSize, requireFabric) {
      return variants.filter(function (variant) {
        if (sizeIndex >= 0 && canonicalSize(variant.options[sizeIndex]) !== targetSize) return false;
        if (requireFabric && fabricIndex >= 0 && fabric && canonicalFabric(variant.options[fabricIndex]) !== requestedFabric) return false;
        return true;
      });
    }

    function exactColorVariant(targetSize, requireFabric) {
      return variantsForSize(targetSize, requireFabric).find(function (variant) {
        return colorIndex < 0 || normalize(variant.options[colorIndex]) === requestedColor;
      }) || null;
    }

    function fallbackColorVariant(targetSize, requireFabric) {
      var sizeVariants = variantsForSize(targetSize, requireFabric);
      var priority = upsellFallbackColors[targetSize] || [];
      for (var index = 0; index < priority.length; index += 1) {
        var fallback = sizeVariants.find(function (variant) {
          return colorIndex < 0 || normalize(variant.options[colorIndex]) === priority[index];
        });
        if (fallback) return fallback;
      }
      return sizeVariants[0] || null;
    }

    function resolve(requireFabric) {
      var variant = exactColorVariant(requestedSize, requireFabric);
      if (variant) return variant;

      if (prioritizeColorAcrossSizes) {
        for (var exactSizeIndex = 1; exactSizeIndex < sizes.length; exactSizeIndex += 1) {
          variant = exactColorVariant(sizes[exactSizeIndex], requireFabric);
          if (variant) return variant;
        }
      }

      variant = fallbackColorVariant(requestedSize, requireFabric);
      if (variant) return variant;

      for (var sizeKeyIndex = 1; sizeKeyIndex < sizes.length; sizeKeyIndex += 1) {
        if (!prioritizeColorAcrossSizes) {
          variant = exactColorVariant(sizes[sizeKeyIndex], requireFabric);
          if (variant) return variant;
        }
        variant = fallbackColorVariant(sizes[sizeKeyIndex], requireFabric);
        if (variant) return variant;
      }
      return null;
    }

    var resolvedVariant = resolve(true) || resolve(false) || variants[0];
    return {
      variant: resolvedVariant,
      color: colorIndex >= 0 ? resolvedVariant.options[colorIndex] : color,
      size: sizeIndex >= 0 ? resolvedVariant.options[sizeIndex] : size
    };
  }

  function formatMoney(cents, currency) {
    var value = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency || 'USD',
        minimumFractionDigits: value % 1 ? 2 : 0,
        maximumFractionDigits: 2
      }).format(value);
    } catch (error) {
      return '$' + value.toFixed(value % 1 ? 2 : 0);
    }
  }

  function variantImage(variant, product) {
    if (variant && variant.featured_image && variant.featured_image.src) return variant.featured_image.src;
    if (product && product.featured_image) return product.featured_image;
    if (product && product.images && product.images.length) {
      return typeof product.images[0] === 'string' ? product.images[0] : product.images[0].src;
    }
    return '';
  }

  function findGiftVariant(product, selectedColor) {
    if (!product || !Array.isArray(product.variants) || !product.variants.length) return null;
    var variants = availableVariants(product);
    if (!variants.length) variants = product.variants.slice();
    var colorIndex = getOptionIndex(product, 'color');
    if (colorIndex < 0) return variants[0] || null;

    var normColor = normalize(selectedColor);
    // Exact color match if present. Some dedicated gift SKUs include the
    // product name in the option value, e.g. "FREE 3pc Towel Set (Sky Blue)".
    var exact = variants.find(function (v) {
      var optionColor = normalize(v.options[colorIndex]);
      return optionColor === normColor || optionColor.endsWith(' ' + normColor);
    });
    if (exact) return exact;

    // Match the live KSP: light/cool sheet colors receive White towels.
    if (usesWhiteTowel(normColor)) {
      var whiteVariant = variants.find(function (v) {
        var opt = normalize(v.options[colorIndex]);
        return opt === 'white' || opt.indexOf('white') !== -1;
      });
      if (whiteVariant) return whiteVariant;
    }

    // All other sheet colors -> Stone towel variant
    var stoneVariant = variants.find(function (v) {
      var opt = normalize(v.options[colorIndex]);
      return opt === 'stone' || opt.indexOf('stone') !== -1;
    });
    if (stoneVariant) return stoneVariant;

    return variants[0] || null;
  }

  function initPdp(root) {
    if (!root || root.dataset.tmPdpInitialized === 'true') return;
    root.dataset.tmPdpInitialized = 'true';

    var mainProduct = parseProduct(root, '[data-main-product-json]');
    var mainProductWithGift = parseProduct(root, '[data-main-product-with-gift-json]');
    var giftProduct = parseProduct(root, '[data-gift-product-json]');
    var upsellProduct = parseProduct(root, '[data-upsell-product-json]');
    if (root.dataset.excludeExtraLuxe === 'true') {
      mainProduct = excludeExtraLuxe(mainProduct);
      mainProductWithGift = excludeExtraLuxe(mainProductWithGift);
      upsellProduct = excludeExtraLuxe(upsellProduct);
    }
    var offerImageConfig = parseProduct(root, '[data-offer-image-config]') || {};
    var currency = root.dataset.currency || 'USD';
    var dynamicPdp = root.dataset.dynamicPdp === 'true' && mainProduct;

    var galleryTrack = root.querySelector('.tm-gallery-track');
    var galleryThumbs = root.querySelector('.tm-gallery-thumbs');
    var galleryDots = root.querySelector('.tm-gallery-dots');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-thumb]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-dot]'));
    var activeIndex = 0;
    var galleryUpdateToken = 0;
    var galleryNavigationToken = 0;

    var galleryConfig = parseProduct(root, '[data-gallery-config]') || {};

    function galleryColorSlug(color) {
      var colorMap = {
        navy: 'navy_blue',
        'navy blue': 'navy_blue',
        'silver grey': 'silver_grey',
        'sky blue': 'sky_blue',
        'slate blue': 'slate_blue'
      };
      var normalized = normalize(color);
      if (colorMap[normalized]) return colorMap[normalized];
      var slug = normalized.replace(/\s+/g, '_');
      return colorMap[slug] || slug;
    }

    function bindThumbEvents() {
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          showSlide(parseInt(thumb.dataset.galleryThumb, 10) || 0);
        });
      });
    }

    function updateLandingGallery(color) {
      if (root.dataset.useProductMedia === 'true') return;
      if (!galleryTrack || !galleryThumbs) return;

      var slug = galleryColorSlug(color);
      var galleryImages = Array.isArray(galleryConfig[slug]) ? galleryConfig[slug].filter(function (image) {
        return image && image.src;
      }) : [];
      if (!galleryImages.length) return;
      var productName = root.dataset.productName || 'Miracle Made Sheets';
      var updateToken = ++galleryUpdateToken;
      var primaryImage = new Image();
      var primaryReadyHandled = false;
      primaryImage.decoding = 'async';
      primaryImage.fetchPriority = 'high';

      function commitGallery() {
        if (updateToken !== galleryUpdateToken) return;

        var slideHtml = '';
        var thumbHtml = '';
        var dotHtml = '';

        for (var i = 0; i < galleryImages.length; i++) {
          var image = galleryImages[i];
          var imgUrl = image.src;
          var thumbUrl = image.thumb || imgUrl;
          var imageAlt = image.alt || productName;
          slideHtml += '<figure class="tm-gallery-slide' + (i === 0 ? ' is-active' : '') + '" data-gallery-slide="' + i + '">';
          slideHtml += '<img src="' + imgUrl + '" alt="' + imageAlt + '" width="1800" height="1000" loading="' + (i === 0 ? 'eager' : 'lazy') + '"' + (i === 0 ? ' fetchpriority="high"' : '') + '>';
          slideHtml += '</figure>';

          thumbHtml += '<button class="tm-gallery-thumb' + (i === 0 ? ' is-active' : '') + '" type="button" data-gallery-thumb="' + i + '" aria-label="View image ' + (i + 1) + '">';
          thumbHtml += '<img src="' + thumbUrl + '" alt="" width="90" height="74" loading="lazy">';
          thumbHtml += '</button>';

          dotHtml += '<span class="' + (i === 0 ? 'is-active' : '') + '" data-gallery-dot="' + i + '"></span>';
        }

        // A swatch can replace a 7-image gallery with one containing only 5 or
        // 6 images. Reset the stale translate value without animating through an
        // invalid position, then restore normal arrow/thumbnail transitions.
        activeIndex = 0;
        galleryNavigationToken += 1;
        galleryTrack.style.transition = 'none';
        galleryTrack.style.transform = 'translate3d(0%, 0, 0)';
        galleryTrack.innerHTML = slideHtml;
        galleryThumbs.innerHTML = thumbHtml;
        if (galleryDots) galleryDots.innerHTML = dotHtml;

        slides = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-slide]'));
        thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-thumb]'));
        dots = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-dot]'));

        bindThumbEvents();
        applySlide(0);
        // Force the reset frame to commit before the CSS transition is restored.
        galleryTrack.offsetWidth;
        window.requestAnimationFrame(function () {
          if (updateToken === galleryUpdateToken) galleryTrack.style.removeProperty('transition');
        });
      }

      function handlePrimaryReady() {
        if (updateToken !== galleryUpdateToken || primaryReadyHandled) return;
        primaryReadyHandled = true;
        if (typeof primaryImage.decode === 'function') {
          primaryImage.decode().catch(function () {}).then(commitGallery);
        } else {
          commitGallery();
        }
      }

      primaryImage.onload = handlePrimaryReady;
      primaryImage.onerror = function () {
        // Keep the current gallery visible when the incoming hero cannot load.
        // A later swatch interaction can retry without exposing an empty stage.
      };
      primaryImage.src = galleryImages[0].src;
      if (primaryImage.complete && primaryImage.naturalWidth > 0) handlePrimaryReady();
    }

    function applySlide(nextIndex) {
      activeIndex = nextIndex;
      if (galleryTrack) {
        galleryTrack.style.transform = 'translate3d(' + (-activeIndex * 100) + '%, 0, 0)';
      }
      slides.forEach(function (slide, index) {
        slide.classList.toggle('is-active', index === activeIndex);
      });
      thumbs.forEach(function (thumb, index) {
        thumb.classList.toggle('is-active', index === activeIndex);
        thumb.setAttribute('aria-current', index === activeIndex ? 'true' : 'false');
      });
      dots.forEach(function (dot, index) {
        dot.classList.toggle('is-active', index === activeIndex);
      });
    }

    function showSlide(nextIndex) {
      if (!slides.length) return;
      var targetIndex = (nextIndex + slides.length) % slides.length;
      var targetSlide = slides[targetIndex];
      var targetImage = targetSlide && targetSlide.querySelector('img');
      var navigationToken = ++galleryNavigationToken;
      var updateToken = galleryUpdateToken;

      function activateTarget() {
        if (navigationToken !== galleryNavigationToken || updateToken !== galleryUpdateToken) return;
        applySlide(targetIndex);
      }

      function activateDecodedTarget() {
        if (!targetImage || targetImage.naturalWidth <= 0) return;
        if (typeof targetImage.decode === 'function') {
          targetImage.decode().catch(function () {}).then(activateTarget);
        } else {
          activateTarget();
        }
      }

      if (!targetImage) {
        activateTarget();
        return;
      }
      if (targetImage.complete && targetImage.naturalWidth > 0) {
        activateDecodedTarget();
        return;
      }

      // Do not slide onto an unpainted lazy image. Keep the current slide in
      // place until the requested image is downloaded and decoded.
      targetImage.loading = 'eager';
      targetImage.fetchPriority = 'high';
      targetImage.addEventListener('load', activateDecodedTarget, { once: true });
    }

    function showVariantImage(variant) {
      if (!variant || !variant.featured_image || !variant.featured_image.id) return;
      var targetId = String(variant.featured_image.id);
      var targetIndex = slides.findIndex(function (slide) {
        return slide.dataset.mediaId === targetId;
      });
      if (targetIndex >= 0) showSlide(targetIndex);
    }

    var previous = root.querySelector('[data-gallery-prev]');
    var next = root.querySelector('[data-gallery-next]');
    if (previous) previous.addEventListener('click', function () { showSlide(activeIndex - 1); });
    if (next) next.addEventListener('click', function () { showSlide(activeIndex + 1); });
    bindThumbEvents();

    var touchStartX = null;
    var touchStartY = null;
    var gallery = root.querySelector('[data-gallery]');
    if (gallery) {
      gallery.addEventListener('touchstart', function (event) {
        touchStartX = event.touches[0].clientX;
        touchStartY = event.touches[0].clientY;
      }, { passive: true });
      gallery.addEventListener('touchend', function (event) {
        if (touchStartX === null) return;
        var diffX = event.changedTouches[0].clientX - touchStartX;
        var diffY = event.changedTouches[0].clientY - (touchStartY || 0);
        if (Math.abs(diffX) > 35 && Math.abs(diffX) > Math.abs(diffY)) {
          showSlide(activeIndex + (diffX < 0 ? 1 : -1));
        }
        touchStartX = null;
        touchStartY = null;
      }, { passive: true });
    }

    var swatches = Array.prototype.slice.call(root.querySelectorAll('.tm-swatch'));
    var swatchList = root.querySelector('.tm-swatches');
    var colorLabel = root.querySelector('[data-color-label]');
    var colorBadge = root.querySelector('[data-color-badge]');
    var colorBadgeText = root.querySelector('[data-color-badge-text]');
    var upsellColor = root.querySelector('[data-upsell-color]');
    var sizeSelect = root.querySelector('[data-size-select]');
    var customSelect = root.querySelector('[data-custom-select]');
    var selectTrigger = root.querySelector('[data-select-trigger]');
    var selectLabel = root.querySelector('[data-select-label]');
    var mobileSelectedSize = root.querySelector('[data-mobile-selected-size]');
    var optionAdjustment = root.querySelector('[data-option-adjustment]');
    var configuredSizeOrder = String(root.dataset.sizeOrder || '')
      .split(',')
      .map(function (value) { return canonicalSize(value); })
      .filter(Boolean);

    function sizeDisplayRank(value) {
      var rank = configuredSizeOrder.indexOf(canonicalSize(value));
      return rank === -1 ? configuredSizeOrder.length : rank;
    }

    function reorderSizeNodes(parent, nodes, getValue) {
      if (!parent || !configuredSizeOrder.length) return;
      nodes
        .map(function (node, index) {
          return { node: node, index: index, rank: sizeDisplayRank(getValue(node)) };
        })
        .sort(function (left, right) {
          return left.rank - right.rank || left.index - right.index;
        })
        .forEach(function (item) { parent.appendChild(item.node); });
    }

    if (sizeSelect) {
      reorderSizeNodes(sizeSelect, Array.prototype.slice.call(sizeSelect.options), function (option) { return option.value; });
    }
    var selectOptionsContainer = root.querySelector('[data-select-options]');
    if (selectOptionsContainer) {
      reorderSizeNodes(selectOptionsContainer, Array.prototype.slice.call(selectOptionsContainer.querySelectorAll('[data-size-option]')), function (option) {
        return option.dataset.sizeOption;
      });
    }
    var selectOptions = Array.prototype.slice.call(root.querySelectorAll('[data-size-option]'));
    var mobileSizeList = root.querySelector('[data-mobile-size-list]');
    var mobileQuantity = root.querySelector('[data-mobile-qty]');
    var mobileQuantityTrigger = root.querySelector('[data-mobile-qty-trigger]');
    var mobileQuantityList = root.querySelector('[data-mobile-qty-list]');
    var mobileQuantityValue = root.querySelector('[data-mobile-qty-value]');
    var mobileQuantityOptions = Array.prototype.slice.call(root.querySelectorAll('[data-mobile-qty-option]'));
    var comparePrice = root.querySelector('[data-compare-price]');
    var salePrice = root.querySelector('[data-sale-price]');
    var discountText = root.querySelector('[data-discount-text]');
    var checkoutButton = root.querySelector('[data-checkout]');
    var errorMessage = root.querySelector('[data-product-error]');
    var giftCheckbox = root.querySelector('[data-gift-option]');
    var upsellCheckbox = root.querySelector('[data-upsell-option]');
    var giftImage = root.querySelector('[data-gift-image]');
    var upsellImage = root.querySelector('[data-upsell-image]');
    var upsellPrice = root.querySelector('[data-upsell-price]');
    var upsellCompare = root.querySelector('[data-upsell-compare]');
    var upsellDiscount = root.querySelector('[data-upsell-discount]');
    var upsellSizes = root.querySelector('[data-upsell-sizes]');
    var selectedVariant = null;
    var selectedColor = '';
    var selectedSize = '';
    var selectedFabric = '';
    // Keep the shopper's fabric preference when a color requires a fallback.
    var preferredFabric = '';
    var selectedUpsellSize = '';

    function selectorMaxScroll(container) {
      if (!container) return 0;
      return Math.max(0, container.scrollWidth - container.clientWidth);
    }

    function scrollSelectorTo(container, target, behavior) {
      if (!container || container.clientWidth <= 0) return;
      var numericTarget = Number(target);
      if (!Number.isFinite(numericTarget)) numericTarget = 0;
      var safeTarget = Math.max(0, Math.min(selectorMaxScroll(container), numericTarget));
      try {
        container.scrollTo({ left: safeTarget, behavior: behavior || 'auto' });
      } catch (error) {
        container.scrollLeft = safeTarget;
      }
    }

    function centerSelectorItem(container, item, behavior) {
      if (!container || !item || container.clientWidth <= 0) return;
      var containerRect = container.getBoundingClientRect();
      var itemRect = item.getBoundingClientRect();
      var target = container.scrollLeft + (itemRect.left - containerRect.left) - ((container.clientWidth - itemRect.width) / 2);
      scrollSelectorTo(container, target, behavior);
    }

    function scheduleSelectorCenter(container, selector, behavior) {
      if (!container) return;
      var align = function () {
        centerSelectorItem(container, container.querySelector(selector), behavior);
      };
      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(align);
        });
      } else {
        window.setTimeout(align, 0);
      }
    }

    function alignActiveMobileSelectors(behavior) {
      scheduleSelectorCenter(swatchList, '.tm-swatch.is-active', behavior || 'auto');
      scheduleSelectorCenter(mobileSizeList, '.tm-mobile-size.is-active', behavior || 'auto');
    }

    function variantForSize(size) {
      if (!mainProduct) return null;
      return resolveVariant(mainProduct, selectedColor, size, preferredFabric);
    }

    function renderMobileSizes(keepCentered) {
      if (!mobileSizeList || !sizeSelect) return;
      var values = Array.prototype.slice.call(sizeSelect.options).map(function (option) { return option.value; });
      mobileSizeList.innerHTML = '';
      values.forEach(function (value) {
        var variant = variantForSize(value);
        var unavailable = !!mainProduct && (!variant || !variant.available);
        var price = variant ? Number(variant.price || 0) : 0;
        var compare = variant ? Number(variant.compare_at_price || 0) : 0;
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'tm-mobile-size';
        button.dataset.mobileSize = value;
        button.classList.toggle('is-active', canonicalSize(value) === canonicalSize(selectedSize));
        button.classList.toggle('is-unavailable', unavailable);
        button.innerHTML = '<span class="tm-mobile-size-name"></span><span class="tm-mobile-size-price"></span><span class="tm-mobile-size-stock"></span>';
        button.querySelector('.tm-mobile-size-name').textContent = friendlySize(value);
        var priceNode = button.querySelector('.tm-mobile-size-price');
        var stockNode = button.querySelector('.tm-mobile-size-stock');
        if (unavailable) {
          priceNode.hidden = true;
          stockNode.classList.add('tm-mobile-size-availability');
          stockNode.textContent = 'See available options';
          button.setAttribute('aria-label', friendlySize(value) + ', see available options');
        } else if (variant) {
          if (compare > price) {
            var oldPrice = document.createElement('del');
            oldPrice.textContent = formatMoney(compare, currency);
            priceNode.appendChild(oldPrice);
          }
          priceNode.appendChild(document.createTextNode(formatMoney(price, currency)));
        } else {
          priceNode.textContent = salePrice ? salePrice.textContent : '';
        }
        if (!unavailable) stockNode.textContent = 'In stock';
        mobileSizeList.appendChild(button);
      });
      if (keepCentered) {
        scheduleSelectorCenter(mobileSizeList, '.tm-mobile-size.is-active', 'auto');
      }
    }

    function setError(message) {
      if (!errorMessage) return;
      errorMessage.textContent = message || '';
      errorMessage.hidden = !message;
    }

    function setOptionAdjustment(visible) {
      if (!optionAdjustment) return;
      optionAdjustment.hidden = !visible;
    }

    function updatePrice(variant) {
      if (!variant) return;
      var price = Number(variant.price || 0);
      var compare = Number(variant.compare_at_price || 0);
      if (salePrice) salePrice.textContent = formatMoney(price, currency);

      if (comparePrice) {
        comparePrice.hidden = !(compare > price);
        if (compare > price) comparePrice.textContent = formatMoney(compare, currency);
      }

      if (discountText) {
        discountText.hidden = !(compare > price);
        if (compare > price) {
          var percent = Math.floor(((compare - price) / compare) * 100);
          discountText.textContent = percent + '% OFF - YOU SAVE ' + formatMoney(compare - price, currency);
        }
      }
    }

    function updateRelatedProducts(prioritizeUpsellColor) {
      var giftVariant = findGiftVariant(giftProduct, selectedColor);
      if (giftCheckbox) {
        giftCheckbox.dataset.variantId = giftVariant ? String(giftVariant.id) : '';
        giftCheckbox.disabled = !!giftProduct && !giftVariant;
        if (giftCheckbox.disabled) giftCheckbox.checked = false;
        giftCheckbox.closest('.tm-bonus-card').classList.toggle('is-disabled', giftCheckbox.disabled);
      }

      var towelKey = usesWhiteTowel(selectedColor) ? 'white' : 'stone';
      var nextGiftImage = offerImageConfig.towels && offerImageConfig.towels[towelKey];
      if (!nextGiftImage) nextGiftImage = giftVariant && variantImage(giftVariant, giftProduct);
      if (giftImage && nextGiftImage) {
        giftImage.removeAttribute('srcset');
        giftImage.removeAttribute('sizes');
        giftImage.src = nextGiftImage;
      }

      // A sheet fabric fallback must not change the shopper's pillowcase preference.
      var upsellResolution = findRelatedVariant(upsellProduct, selectedColor, selectedUpsellSize, preferredFabric, prioritizeUpsellColor);
      var upsellVariant = upsellResolution && upsellResolution.variant;
      var resolvedUpsellColor = upsellResolution ? upsellResolution.color : selectedColor;
      if (upsellResolution && upsellResolution.size) selectedUpsellSize = upsellResolution.size;
      if (upsellCheckbox) {
        upsellCheckbox.dataset.variantId = upsellVariant ? String(upsellVariant.id) : '';
        upsellCheckbox.disabled = !!upsellProduct && !upsellVariant;
        if (upsellCheckbox.disabled) upsellCheckbox.checked = false;
        upsellCheckbox.closest('.tm-upsell-card').classList.toggle('is-disabled', upsellCheckbox.disabled);
      }
      if (upsellColor) upsellColor.textContent = friendlyColor(resolvedUpsellColor);
      if (upsellSizes) {
        Array.prototype.slice.call(upsellSizes.querySelectorAll('[data-upsell-size]')).forEach(function (item) {
          item.classList.toggle('is-active', canonicalSize(item.dataset.upsellSize) === canonicalSize(selectedUpsellSize));
        });
      }

      if (upsellVariant) {
        var upPrice = Number(upsellVariant.price || 0);
        var upCompare = Number(upsellVariant.compare_at_price || 0);
        if (upsellPrice) upsellPrice.textContent = formatMoney(upPrice, currency) + '*';
        if (upsellCompare) {
          upsellCompare.hidden = !(upCompare > upPrice);
          if (upCompare > upPrice) upsellCompare.textContent = formatMoney(upCompare, currency);
        }
        if (upsellDiscount) {
          upsellDiscount.hidden = !(upCompare > upPrice);
        }
      }

      var upsellImageSlug = normalize(resolvedUpsellColor).replace(/\s+/g, '_');
      if (upsellImageSlug === 'navy') upsellImageSlug = 'navy_blue';
      var nextUpsellImage = offerImageConfig.upsells && offerImageConfig.upsells[upsellImageSlug];
      if (!nextUpsellImage) nextUpsellImage = variantImage(upsellVariant, upsellProduct);
      if (upsellImage && nextUpsellImage) {
        upsellImage.removeAttribute('srcset');
        upsellImage.removeAttribute('sizes');
        upsellImage.src = nextUpsellImage;
      }
    }

    function updateAvailability() {
      if (!mainProduct) return;
      var colorIndex = getOptionIndex(mainProduct, 'color');
      var sizeIndex = getOptionIndex(mainProduct, 'size');

      swatches.forEach(function (swatch) {
        var hasAvailableSize = mainProduct.variants.some(function (variant) {
          return variant.available && (colorIndex < 0
            || normalize(variant.options[colorIndex]) === normalize(swatch.dataset.color));
        });
        var available = mainProduct.variants.some(function (variant) {
          if (!variant.available) return false;
          if (colorIndex >= 0 && normalize(variant.options[colorIndex]) !== normalize(swatch.dataset.color)) return false;
          if (sizeIndex >= 0 && selectedSize && canonicalSize(variant.options[sizeIndex]) !== canonicalSize(selectedSize)) return false;
          return true;
        });
        swatch.classList.toggle('is-unavailable', !available);
        // Keep unavailable colors clickable so they can select an available fallback.
        swatch.disabled = false;
        swatch.dataset.hasAvailableSize = hasAvailableSize ? 'true' : 'false';
        swatch.setAttribute('aria-disabled', hasAvailableSize ? 'false' : 'true');
      });

      if (sizeSelect && sizeIndex >= 0) {
        Array.prototype.slice.call(sizeSelect.options).forEach(function (option) {
          option.disabled = !mainProduct.variants.some(function (variant) {
            if (!variant.available) return false;
            if (canonicalSize(variant.options[sizeIndex]) !== canonicalSize(option.value)) return false;
            if (colorIndex >= 0 && selectedColor && normalize(variant.options[colorIndex]) !== normalize(selectedColor)) return false;
            return true;
          });
        });
      }

      if (selectOptions.length && sizeIndex >= 0 && mainProduct) {
        selectOptions.forEach(function (opt) {
          var sizeVal = opt.dataset.sizeOption;
          var available = mainProduct.variants.some(function (variant) {
            if (!variant.available) return false;
            if (canonicalSize(variant.options[sizeIndex]) !== canonicalSize(sizeVal)) return false;
            if (colorIndex >= 0 && selectedColor && normalize(variant.options[colorIndex]) !== normalize(selectedColor)) return false;
            return true;
          });
          opt.classList.toggle('is-disabled', !available);
          opt.setAttribute('aria-disabled', !available ? 'true' : 'false');
        });
      }
    }

    function closeCustomSelect() {
      if (!customSelect) return;
      customSelect.classList.remove('is-open');
      if (selectTrigger) selectTrigger.setAttribute('aria-expanded', 'false');
    }

    function openCustomSelect() {
      if (!customSelect) return;
      customSelect.classList.add('is-open');
      if (selectTrigger) selectTrigger.setAttribute('aria-expanded', 'true');
    }

    function updateCustomSelectUI(size) {
      if (selectLabel) selectLabel.textContent = friendlySize(size);
      if (mobileSelectedSize) mobileSelectedSize.textContent = friendlySize(size);
      selectOptions.forEach(function (opt) {
        var isMatch = canonicalSize(opt.dataset.sizeOption) === canonicalSize(size);
        opt.classList.toggle('is-selected', isMatch);
        opt.setAttribute('aria-selected', isMatch ? 'true' : 'false');
      });
    }

    function updateColorBadge(color) {
      if (!colorBadge) return;
      var activeSwatch = root.querySelector('.tm-swatch.is-active');
      if (!activeSwatch && color) {
        activeSwatch = swatches.find(function (swatch) {
          return normalize(swatch.dataset.color) === normalize(color);
        }) || null;
      }
      var badge = activeSwatch ? (activeSwatch.dataset.badge || '') : '';
      if (!badge && normalize(color) === 'sage') {
        badge = 'LIMITED EDITION DROP';
      }
      if (badge && badge.trim()) {
        if (colorBadgeText) colorBadgeText.textContent = badge.trim();
        colorBadge.style.display = 'inline-flex';
      } else {
        colorBadge.style.display = 'none';
      }
    }

    function syncMainVariant(updateUrl, prioritizeUpsellColor) {
      if (!mainProduct) return;
      selectedVariant = resolveVariant(mainProduct, selectedColor, selectedSize, preferredFabric);
      var fabricIndex = getOptionIndex(mainProduct, 'fabric');
      if (selectedVariant && fabricIndex >= 0) selectedFabric = selectedVariant.options[fabricIndex];
      updateAvailability();
      updateCustomSelectUI(selectedSize);
      updateColorBadge(selectedColor);
      updateRelatedProducts(prioritizeUpsellColor);
      renderMobileSizes(true);

      if (!selectedVariant) {
        setError('This option combination is unavailable.');
        if (checkoutButton) checkoutButton.disabled = true;
        return;
      }

      updatePrice(selectedVariant);
      showVariantImage(selectedVariant);
      if (checkoutButton) checkoutButton.disabled = !selectedVariant.available;
      setError(selectedVariant.available ? '' : 'This option combination is sold out.');

      if (updateUrl && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', selectedVariant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    function chooseColor(swatch) {
      if (swatch.dataset.hasAvailableSize === 'false') {
        swatch = swatches.find(function (item) {
          return item.dataset.hasAvailableSize === 'true';
        });
        if (!swatch) return;
      }
      var adjustedOtherOption = false;
      selectedColor = swatch.dataset.color;
      swatches.forEach(function (item) {
        var active = item === swatch;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      if (colorLabel) colorLabel.textContent = friendlyColor(selectedColor);
      updateColorBadge(selectedColor);
      scheduleSelectorCenter(swatchList, '.tm-swatch.is-active', 'smooth');
      updateLandingGallery(selectedColor);
      if (dynamicPdp) {
        var nextVariant = resolveVariant(mainProduct, selectedColor, selectedSize, preferredFabric);
        if (!nextVariant || !nextVariant.available) {
          var colorIndex = getOptionIndex(mainProduct, 'color');
          var fabricIndex = getOptionIndex(mainProduct, 'fabric');
          var sizeIndex = getOptionIndex(mainProduct, 'size');
          var colorVariants = mainProduct.variants.filter(function (variant) {
            if (!variant.available) return false;
            if (colorIndex >= 0 && normalize(variant.options[colorIndex]) !== normalize(selectedColor)) return false;
            return true;
          });
          nextVariant = colorVariants.find(function (variant) {
            return fabricIndex < 0 || !preferredFabric || canonicalFabric(variant.options[fabricIndex]) === canonicalFabric(preferredFabric);
          }) || colorVariants[0] || null;
          if (nextVariant && sizeIndex >= 0) {
            adjustedOtherOption = canonicalSize(nextVariant.options[sizeIndex]) !== canonicalSize(selectedSize);
            selectedSize = nextVariant.options[sizeIndex];
            if (sizeSelect) sizeSelect.value = selectedSize;
          }
        }
        setOptionAdjustment(adjustedOtherOption);
        syncMainVariant(true, true);
      } else {
        setOptionAdjustment(false);
        updateRelatedProducts(true);
        renderMobileSizes(true);
      }
    }

    function chooseSize(size) {
      var adjustedOtherOption = false;
      selectedSize = size;
      if (sizeSelect) sizeSelect.value = selectedSize;

      if (dynamicPdp && mainProduct) {
        var nextVariant = resolveVariant(mainProduct, selectedColor, selectedSize, preferredFabric);
        if (!nextVariant || !nextVariant.available) {
          var colorIndex = getOptionIndex(mainProduct, 'color');
          var sizeIndex = getOptionIndex(mainProduct, 'size');
          var fabricIndex = getOptionIndex(mainProduct, 'fabric');
          var sizeVariants = mainProduct.variants.filter(function (variant) {
            if (!variant.available) return false;
            if (sizeIndex >= 0 && canonicalSize(variant.options[sizeIndex]) !== canonicalSize(selectedSize)) return false;
            return true;
          });
          var availableVariant = sizeVariants.find(function (variant) {
            return fabricIndex < 0 || !preferredFabric || canonicalFabric(variant.options[fabricIndex]) === canonicalFabric(preferredFabric);
          }) || sizeVariants[0] || null;
          if (availableVariant && colorIndex >= 0) {
            var newColor = availableVariant.options[colorIndex];
            adjustedOtherOption = normalize(newColor) !== normalize(selectedColor);
            selectedColor = newColor;
            swatches.forEach(function (item) {
              var active = normalize(item.dataset.color) === normalize(newColor);
              item.classList.toggle('is-active', active);
              item.setAttribute('aria-pressed', active ? 'true' : 'false');
            });
            if (colorLabel) colorLabel.textContent = friendlyColor(selectedColor);
            updateColorBadge(selectedColor);
            updateLandingGallery(selectedColor);
          }
        }
        setOptionAdjustment(adjustedOtherOption);
        syncMainVariant(true, false);
      } else {
        setOptionAdjustment(false);
        updateCustomSelectUI(selectedSize);
        updateRelatedProducts(false);
        renderMobileSizes(true);
      }
    }

    swatches.forEach(function (swatch) {
      var swatchLabel = swatch.querySelector('span');
      if (swatchLabel) swatchLabel.textContent = friendlyColor(swatch.dataset.color);
      swatch.addEventListener('click', function () { chooseColor(swatch); });
    });

    if (dynamicPdp) {
      var initialVariantId = Number(root.dataset.initialVariantId);
      var mainColorIndex = getOptionIndex(mainProduct, 'color');
      var mainSizeIndex = getOptionIndex(mainProduct, 'size');
      var mainFabricIndex = getOptionIndex(mainProduct, 'fabric');
      var urlVariantId = Number(new URL(window.location.href).searchParams.get('variant'));
      var requestedVariantId = urlVariantId || initialVariantId;
      var defaultColor = root.dataset.defaultColor;
      var defaultSize = root.dataset.defaultSize;
      var defaultFabric = root.dataset.defaultFabric;
      selectedVariant = mainProduct.variants.find(function (variant) { return Number(variant.id) === requestedVariantId; });
      if (!urlVariantId) {
        selectedVariant = findVariant(mainProduct, defaultColor, defaultSize, defaultFabric, true) || selectedVariant;
      }
      selectedVariant = selectedVariant || availableVariants(mainProduct)[0] || mainProduct.variants[0];
      selectedColor = selectedVariant && mainColorIndex >= 0 ? selectedVariant.options[mainColorIndex] : defaultColor;
      selectedSize = selectedVariant && mainSizeIndex >= 0 ? selectedVariant.options[mainSizeIndex] : defaultSize;
      selectedFabric = selectedVariant && mainFabricIndex >= 0 ? selectedVariant.options[mainFabricIndex] : defaultFabric;
      preferredFabric = selectedFabric;
      if (sizeSelect && selectedSize) sizeSelect.value = selectedSize;

      swatches.forEach(function (swatch) {
        var active = normalize(swatch.dataset.color) === normalize(selectedColor);
        swatch.classList.toggle('is-active', active);
        swatch.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      if (colorLabel) colorLabel.textContent = friendlyColor(selectedColor);
      scheduleSelectorCenter(swatchList, '.tm-swatch.is-active', 'auto');
      updateLandingGallery(selectedColor);

      if (upsellProduct && upsellSizes) {
        var upsellSizeIndex = getOptionIndex(upsellProduct, 'size');
        var upsellSizeValues = [];
        if (upsellSizeIndex >= 0) {
          upsellProduct.variants.forEach(function (variant) {
            var value = variant.options[upsellSizeIndex];
            if (upsellSizeValues.indexOf(value) === -1) upsellSizeValues.push(value);
          });
        }
        if (!upsellSizeValues.length) upsellSizeValues.push('Standard');
        selectedUpsellSize = upsellSizeValues[0];
        upsellSizes.innerHTML = '';
        upsellSizeValues.forEach(function (value, index) {
          var button = document.createElement('button');
          button.type = 'button';
          button.dataset.upsellSize = value;
          button.textContent = friendlySize(value);
          button.classList.toggle('is-active', index === 0);
          upsellSizes.appendChild(button);
        });
      }

      syncMainVariant(false, false);
    } else {
      updateColorBadge(selectedColor);
      updateLandingGallery(selectedColor);
      renderMobileSizes(true);
    }

    function formatDynamicShippingDate() {
      var d = new Date();
      d.setDate(d.getDate() + 2);
      var days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      var dayName = days[d.getDay()];
      var monthName = months[d.getMonth()];
      var dateNum = d.getDate();
      var suffix = 'th';
      if (dateNum === 1 || dateNum === 21 || dateNum === 31) suffix = 'st';
      else if (dateNum === 2 || dateNum === 22) suffix = 'nd';
      else if (dateNum === 3 || dateNum === 23) suffix = 'rd';
      return dayName + ', ' + monthName + ' ' + dateNum + suffix;
    }
    var shippingDateEls = root.querySelectorAll('[data-shipping-date]');
    if (shippingDateEls.length) {
      var formattedShipDate = formatDynamicShippingDate();
      shippingDateEls.forEach(function (el) { el.textContent = formattedShipDate; });
    }

    if (selectTrigger) {
      selectTrigger.addEventListener('click', function (e) {
        e.stopPropagation();
        if (customSelect.classList.contains('is-open')) closeCustomSelect();
        else openCustomSelect();
      });
    }

    selectOptions.forEach(function (opt) {
      opt.addEventListener('click', function (e) {
        e.stopPropagation();
        var sizeVal = opt.dataset.sizeOption;
        closeCustomSelect();
        chooseSize(sizeVal);
      });
    });

    document.addEventListener('click', function (e) {
      if (customSelect && !customSelect.contains(e.target)) {
        closeCustomSelect();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && customSelect) {
        closeCustomSelect();
      }
    });

    if (sizeSelect) {
      sizeSelect.addEventListener('change', function () {
        chooseSize(sizeSelect.value);
      });
    }

    if (mobileSizeList) {
      mobileSizeList.addEventListener('click', function (event) {
        var button = event.target.closest('[data-mobile-size]');
        if (!button) return;
        chooseSize(button.dataset.mobileSize);
      });
    }

    function nudgeSelector(container, direction) {
      if (!container) return;
      var firstItem = container.firstElementChild;
      var styles = window.getComputedStyle(container);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      var step = firstItem ? (firstItem.getBoundingClientRect().width + gap) * 2 : container.clientWidth * 0.72;
      scrollSelectorTo(container, container.scrollLeft + (direction * step), 'smooth');
    }
    var swatchPrevious = root.querySelector('[data-swatch-prev]');
    var swatchNext = root.querySelector('[data-swatch-next]');
    var sizePrevious = root.querySelector('[data-size-prev]');
    var sizeNext = root.querySelector('[data-size-next]');
    if (swatchPrevious) swatchPrevious.addEventListener('click', function () { nudgeSelector(swatchList, -1); });
    if (swatchNext) swatchNext.addEventListener('click', function () { nudgeSelector(swatchList, 1); });
    if (sizePrevious) sizePrevious.addEventListener('click', function () { nudgeSelector(mobileSizeList, -1); });
    if (sizeNext) sizeNext.addEventListener('click', function () { nudgeSelector(mobileSizeList, 1); });

    var selectorResizeTimer = null;
    function queueSelectorRealignment() {
      window.clearTimeout(selectorResizeTimer);
      selectorResizeTimer = window.setTimeout(function () {
        alignActiveMobileSelectors('auto');
      }, 80);
    }
    window.addEventListener('pageshow', queueSelectorRealignment, { passive: true });
    window.addEventListener('resize', queueSelectorRealignment, { passive: true });
    window.addEventListener('orientationchange', queueSelectorRealignment, { passive: true });
    alignActiveMobileSelectors('auto');

    if (upsellSizes) {
      upsellSizes.addEventListener('click', function (event) {
        var button = event.target.closest('[data-upsell-size]');
        if (!button) return;
        event.preventDefault();
        selectedUpsellSize = button.dataset.upsellSize;
        Array.prototype.slice.call(upsellSizes.querySelectorAll('[data-upsell-size]')).forEach(function (item) {
          item.classList.toggle('is-active', item === button);
        });
        updateRelatedProducts(false);
      });
    }

    var quantity = 1;
    var quantityOutput = root.querySelector('[data-qty-value]');
    var minus = root.querySelector('[data-qty-minus]');
    var plus = root.querySelector('[data-qty-plus]');
    function closeMobileQuantity() {
      if (!mobileQuantity) return;
      mobileQuantity.classList.remove('is-open');
      if (mobileQuantityTrigger) mobileQuantityTrigger.setAttribute('aria-expanded', 'false');
      if (mobileQuantityList) mobileQuantityList.setAttribute('aria-hidden', 'true');
    }
    function openMobileQuantity() {
      if (!mobileQuantity) return;
      mobileQuantity.classList.add('is-open');
      if (mobileQuantityTrigger) mobileQuantityTrigger.setAttribute('aria-expanded', 'true');
      if (mobileQuantityList) mobileQuantityList.setAttribute('aria-hidden', 'false');
    }
    function updateQuantity() {
      if (quantityOutput) quantityOutput.textContent = String(quantity);
      if (mobileQuantityValue) mobileQuantityValue.textContent = String(quantity);
      mobileQuantityOptions.forEach(function (option) {
        var selected = Number(option.dataset.mobileQtyOption) === quantity;
        option.classList.toggle('is-selected', selected);
        option.setAttribute('aria-selected', selected ? 'true' : 'false');
      });
      // Keep the minus control visually active at the minimum, matching the
      // reference PDP. The click handler below still clamps the value to 1.
      if (minus) minus.disabled = false;
    }
    if (minus) minus.addEventListener('click', function () { quantity = Math.max(1, quantity - 1); updateQuantity(); });
    if (plus) plus.addEventListener('click', function () { quantity = Math.min(10, quantity + 1); updateQuantity(); });
    if (mobileQuantityTrigger) {
      mobileQuantityTrigger.addEventListener('click', function () {
        if (mobileQuantity.classList.contains('is-open')) closeMobileQuantity();
        else openMobileQuantity();
      });
      mobileQuantityTrigger.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowDown') return;
        event.preventDefault();
        openMobileQuantity();
        var selectedOption = mobileQuantityList && mobileQuantityList.querySelector('.is-selected');
        if (selectedOption) selectedOption.focus();
      });
    }
    mobileQuantityOptions.forEach(function (option) {
      option.addEventListener('click', function () {
        quantity = Math.max(1, Math.min(10, Number(option.dataset.mobileQtyOption) || 1));
        updateQuantity();
        closeMobileQuantity();
        if (mobileQuantityTrigger) mobileQuantityTrigger.focus();
      });
    });
    document.addEventListener('click', function (event) {
      if (mobileQuantity && !mobileQuantity.contains(event.target)) closeMobileQuantity();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeMobileQuantity();
    });
    updateQuantity();

    var sizeGuide = root.querySelector('[data-size-guide]');
    var sizeModal = root.querySelector('[data-size-modal]');
    var modalCloses = Array.prototype.slice.call(root.querySelectorAll('[data-modal-close]'));
    if (sizeGuide && sizeModal) {
      sizeGuide.addEventListener('click', function () {
        if (typeof sizeModal.showModal === 'function') sizeModal.showModal();
        else sizeModal.setAttribute('open', '');
      });
    }
    if (sizeModal) modalCloses.forEach(function (modalClose) {
      modalClose.addEventListener('click', function () { sizeModal.close(); });
    });
    if (sizeModal) {
      sizeModal.addEventListener('click', function (event) {
        if (event.target === sizeModal) sizeModal.close();
      });
    }

    var productStage = root.querySelector('[data-product-stage]');
    var stickyBuy = root.querySelector('[data-sticky-buy]');
    if (productStage && stickyBuy && 'IntersectionObserver' in window) {
      var stickyObserver = new IntersectionObserver(function (entries) {
        var isVisible = !entries[0].isIntersecting;
        stickyBuy.classList.toggle('is-visible', isVisible);
        stickyBuy.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
      }, { threshold: 0.05 });
      stickyObserver.observe(productStage);
    }

    Array.prototype.slice.call(root.querySelectorAll('[data-scroll-buy]')).forEach(function (button) {
      button.addEventListener('click', function () {
        var buyPanel = root.querySelector('.tm-buy-panel');
        if (buyPanel) buyPanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    function notifyCartUpdate(eventName, detail) {
      try {
        document.dispatchEvent(new CustomEvent(eventName, { detail: detail }));
      } catch (error) {}
      try {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'try-miracle-pdp', cartData: detail && (detail.cart || detail.response) });
        }
      } catch (error) {}
    }

    function clearCart(silent) {
      return enqueueCartTask(function () {
        return requestCart('cart/clear.js')
          .then(function (cartData) {
            notifyCartUpdate('try-miracle:cart-cleared', { cart: cartData });
            return cartData;
          })
          .catch(function (error) {
            if (!silent) console.warn('Could not clear cart:', error);
          });
      });
    }

    var originalCheckoutLabel = checkoutButton ? checkoutButton.textContent : 'PROCEED TO CHECKOUT';
    var checkoutInFlight = false;

    function resetCheckoutState() {
      checkoutInFlight = false;
      if (checkoutButton) {
        checkoutButton.disabled = !selectedVariant || !selectedVariant.available;
        checkoutButton.classList.remove('is-loading');
        checkoutButton.textContent = originalCheckoutLabel;
      }
    }

    function handleReturnToPage() {
      resetCheckoutState();
      clearCart(true);
    }

    // Restore the button after back-from-checkout. Safari/iOS often restores this
    // page from bfcache, so JS state is still "adding to cart" until pageshow.
    window.addEventListener('pageshow', handleReturnToPage);

    clearCart(true);

    if (checkoutButton) {
      checkoutButton.addEventListener('click', function (event) {
        if (event) event.preventDefault();
        if (checkoutInFlight || !selectedVariant || !selectedVariant.available || checkoutButton.disabled) return;

        var useGiftBundle = Boolean(giftCheckbox && giftCheckbox.checked && mainProductWithGift);
        var checkoutVariant = useGiftBundle
          ? resolveVariant(mainProductWithGift, selectedColor, selectedSize, selectedFabric)
          : selectedVariant;
        var mainVariantId = toVariantId(checkoutVariant && checkoutVariant.id);
        if (!mainVariantId) {
          setError(useGiftBundle
            ? 'The sheet set with free towels is unavailable for this option combination.'
            : 'This option combination is unavailable.');
          return;
        }

        var pairId = 'try-miracle-' + Date.now();
        var itemQuantity = Math.max(1, parseInt(quantity, 10) || 1);
        var includeGift = !!(giftCheckbox && giftCheckbox.checked);
        var mainProperties = {
          '_landing_page': 'try-miracle',
          '_pairId': pairId
        };
        if (includeGift) mainProperties._hasFreeGift = 'true';

        var items = [{
          id: mainVariantId,
          quantity: Math.max(1, parseInt(quantity, 10) || 1),
          properties: {
            '_landing_page': 'try-miracle',
            '_pairId': pairId,
            '_free-gift-offer': useGiftBundle ? 'true' : 'false'
          }
        }];

        if (includeGift) {
          var giftVariantId = toVariantId(giftCheckbox.dataset.variantId);
          if (!giftVariantId) {
            setError('The free towel gift is unavailable for this selection. Uncheck it or choose another color.');
            return;
          }
          items.push({
            id: giftVariantId,
            quantity: itemQuantity,
            properties: {
              '_landing_page': 'try-miracle',
              '_pairId': pairId,
              '_free-gift': 'true',
              '_free-gift-offer': 'true'
            }
          });
        }

        if (upsellCheckbox && upsellCheckbox.checked) {
          var upsellVariantId = toVariantId(upsellCheckbox.dataset.variantId);
          if (!upsellVariantId) {
            setError('The extra pillowcases are unavailable for this selection. Uncheck them or choose another option.');
            return;
          }
          items.push({
            id: upsellVariantId,
            quantity: 1,
            properties: {
              '_landing_page': 'try-miracle',
              '_pairId': pairId,
              '_upsell-offer': 'true'
            }
          });
        }

        setError('');
        checkoutInFlight = true;
        checkoutButton.disabled = true;
        checkoutButton.classList.add('is-loading');
        checkoutButton.textContent = 'ADDING TO CART…';

        enqueueCartTask(function () {
          return requestCart('cart/clear.js')
            .catch(function () {})
            .then(function () {
              return requestCart('cart/add.js', { items: items });
            });
        })
          .then(function (cartData) {
            notifyCartUpdate('try-miracle:added-to-cart', { items: items, response: cartData });
            if (checkoutButton) {
              checkoutButton.classList.remove('is-loading');
              checkoutButton.textContent = originalCheckoutLabel;
            }
            window.location.assign(cartRootPath() + 'checkout');
          })
          .catch(function (error) {
            setError(checkoutErrorMessage(error));
            resetCheckoutState();
          });
      });
    }
  }

  function initReviews(root) {
    if (!root || root.dataset.tmReviewsInitialized === 'true') return;
    root.dataset.tmReviewsInitialized = 'true';
    var reviews = root.querySelector('[data-review-grid]');
    var loadReviews = root.querySelector('[data-load-reviews]');
    if (loadReviews && reviews) {
      loadReviews.addEventListener('click', function () {
        reviews.classList.add('is-expanded');
        var loadReviewsWrap = loadReviews.closest('.tm-load-reviews-wrap');
        if (loadReviewsWrap) loadReviewsWrap.remove();
        else loadReviews.remove();
      });
    }
  }

  function initComeBackTitle() {
    if (window.Shopify && window.Shopify.designMode) return;
    if (document.documentElement.dataset.tmComeBackTitle === 'true') return;
    document.documentElement.dataset.tmComeBackTitle = 'true';

    var originalTitle = document.title || 'Try Miracle Sheets | Miracle Made';
    var chunks = ['🥺 ', 'Come ', ' Back!', ' 🥺'];
    var intervalId = null;

    function restoreTitle() {
      clearInterval(intervalId);
      intervalId = null;
      document.title = originalTitle;
    }

    function animateTitle() {
      clearInterval(intervalId);
      document.title = '🥺';
      var index = 1;
      intervalId = setInterval(function () {
        document.title += chunks[index];
        index = (index + 1) % chunks.length;
        if (index === 1) document.title = '🥺';
      }, 250);
    }

    window.addEventListener('blur', animateTitle);
    window.addEventListener('focus', restoreTitle);
  }

  function initializeSections(scope) {
    findSections(scope, '[data-tm-pdp]').forEach(initPdp);
    findSections(scope, '[data-tm-reviews]').forEach(initReviews);
  }

  function initializeAll() {
    initializeSections(document);
    initComeBackTitle();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll);
  else initializeAll();

  document.addEventListener('shopify:section:load', function (event) {
    initializeSections(event.target);
  });
})();
